/// <reference path="../../../services/data.service.ts" />
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatPaginator } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { PASPrdService } from '../../../services/PASPrd.service';
import { AppService } from '../../../services/app.service';
import { ProductionService } from '../../../services/production.service';
import { RouterService } from '../../../services/router.service';
import { SecurityService } from '../../../services/security.service';
import { IGetGroupComponentData, IGroupComponentData } from '../../Interfaces/Integrations/IProduction';
import { IgrouppaslistResponse } from '../../Interfaces/igrouppas';
import { POGStatuses } from '../../Interfaces/iproduction';
import { IuserPermissionsResponse } from '../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';
import { CompositionDetailComponent } from './CompositionDetail.component';

@Component({
  selector: 'app-compositionslist',
  templateUrl: './compositionslist.component.html'
})

export class CompositionsListComponent implements OnInit, AfterViewInit {

  formFilter: FormGroup;
  subRef$: Subscription;
  r_gridregs: number = 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  message: string="";
  Columns: string[] = [];
  DataGrid: IGroupComponentData[] = [];
  dataList = new MatTableDataSource;
  Permissions: IuserPermissionsResponse[] = [];
  menuPop: IuserPermissionsResponse[] = [];
  menuPopList = new MatTableDataSource;
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList =new MatTableDataSource;
  filtermenu = { type: 'G' };
  _CurrentId: number;
  _CurrentName: string;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  ngAfterViewInit() {
    this.dataList.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private securityService: SecurityService,
    private routerService: RouterService,
    private productionService: ProductionService,
    private permissionService: PermissionsService,
    private pasPrdService: PASPrdService,
private appService: AppService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.formFilter = formBuilder.group({
      name: [this.appService.name],
      status: ['A', Validators.required],
      validator: ['x', Validators.required]
    });
    this.Columns = ['code', 'name', 'typeName', 'b_menu'];
    this.statuslist.push({ code: "A", name: "Activo" }, { code: "I", name: "Inactivo" });
  }
  selectedvalue: number; selectedview: string;
  group: IgrouppaslistResponse[];
  statuslist: POGStatuses[] = [];

  ngOnInit() {
    this.message= "";
    //permisos
    this.Permissions = [];
    this.menuPop = [];
    this.MenuG = [];
    this.permissionService.getPermission("variantcompositions").subscribe(results => {
      if (results.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of results.body) {
        this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
      }
      this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
      this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
      this.menuPopList = new MatTableDataSource<IuserPermissionsResponse>(this.menuPop);
    },
      (e) => {
        this.message  =  e.error;
        console.log(e);
      });
  }

  Filter() {
    //pasoptions
    this.formFilter.get('validator').setValue('');
    this.message = "Consultando...";
    this.DataGrid = [];
    this.r_gridregs = 0;
    const GetData: IGetGroupComponentData =
    {
      nameText : this.formFilter.value.name,
        status : this.formFilter.get("status").value
    }
    this.pasPrdService.GetCompositionGroups(GetData).subscribe(result => {
      this.dataList = null;
      if (!result.body.isValid) {
        this.message = result.body.error.description;
        this.formFilter.get('validator').setValue('x');
     }
      else {
        this.message = "";
        for (const entry of result.body.resultData)
        {
          this.addData(entry);
        }
        this.dataList = new MatTableDataSource < IGroupComponentData > (this.DataGrid);
        this.dataList.paginator = this.paginator;
        this.r_gridregs = this.dataList.data.length;
        this.formFilter.get('validator').setValue('x');
      }
      if (this.appService.currentPage > 0) {
        this.paginator.pageIndex = this.appService.currentPage;
      }
      this.dataList.paginator = this.paginator;
    },
      (e) => {
        this.openSB(e.error);
        console.log(e);
      });
  }


  addData(data) {
      this.DataGrid.push(data);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    switch (permission.type) {
      case "G":
        this.MenuG.push(permission);
        break;
      case "R":
        this.menuPop.push(permission);
        break;
    }
  }

  //b_det(id, name) {
  //  this.routeparent.putRouter("paslist");
  //  this.passervice.putValues(id, name)
  //  this.router.navigate(['/pasdetail']);
  //}

  b_back() {
    this.appService.PASOptionsGroupPutValues("", 0);
    var route = this.routerService.getBackRoute();
    this.router.navigate([route], { skipLocationChange: true });
  }


  b_gen(link,id,  pCode) {
    switch (pCode) {
      case "A":
        this.b_Add();
        break;
      default:
        this.router.navigate([link]);
        break;
    }
  }

  GetCurrentId(Id: number, Name:string)
  {
    this._CurrentId = Id;
    this._CurrentName = Name;
    this.appService.PASOptionsGroupPutValues(this.formFilter.value.name, this.paginator.pageIndex);
  }

  menupopexecute(FunctionCode: string, PrmCode: string, Link: string) {
    this.routerService.putRouter("pasoptionsgroup");
    switch (PrmCode) {
      case "D":
        this.b_Detail(this._CurrentId);
        break;
      case "M":
        this.b_Edit(this._CurrentId);
        break;
      case "O":
        Link += "/" + this._CurrentId+"/"+encodeURIComponent(this._CurrentName);
        this.router.navigate([Link], { skipLocationChange: true });
        break;
      default:
        this.router.navigate([Link], { skipLocationChange: true });
        break;
    }
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  b_Add() {
  //  const dialogConfig : MatDialogConfig=
  //  {
  //    disableClose: true,
  //    autoFocus : true,
  //    panelClass : "my-class"
  //  };
  //  const dialogRef = this.dialog.open(IOptionGroupsAddComponent, dialogConfig);
  //  dialogRef.afterClosed().subscribe(
  //    data => {
  //      if (data) {
  //        console.log("grabado");
  //        this.Filter();
  //      }
  //      else {
  //        console.log('Undefined data.');
  //      }
  //    }, (e) => console.log(e)
  //  );
  }

  b_Edit(_id) {
  //  const dialogConfig = new MatDialogConfig();
  //  dialogConfig.disableClose = true;
  //  dialogConfig.autoFocus = true;
  //  dialogConfig.panelClass = "my-class";
  //  dialogConfig.data = { id:_id };
  //  const dialogRef = this.dialog.open(OptionGroupsEditComponent, dialogConfig);
  //  dialogRef.afterClosed().subscribe(
  //    data => {
  //      if (data) {
  //        this.Filter();
  //        console.log("grabado");
  //      }
  //      else {
  //        console.log('Undefined data.');
  //      }
  //    }, (e) => console.log(e)
  //  );
  }

  b_Detail(_id) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = "my-class-detail";
      dialogConfig.data = { id:_id };
      const dialogRef = this.dialog.open(CompositionDetailComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(
        data => {
          if (data) {
            //this.Filter();
            //console.log("grabado");
          }
          else {
            //console.log('Undefined data.');
          }
        }, (e) => console.log(e)
      );
  }

}
